import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getCalendarByDateRange = ({ start_date, end_date }) => {
  return api.get(`admin/calendar/date-range/search`, {
    params: { start_date, end_date }
  });
};

export const getCalendarByDateRangeQueryOptions = params => {
  return queryOptions({
    queryKey: ["calendar-date-range", params],
    queryFn: () => getCalendarByDateRange(params),
  });
};

export const useCalendarByDateRangeQuery = ({ queryConfig = {}, ...params }) => {
  return useQuery({
    ...getCalendarByDateRangeQueryOptions(params),
    ...queryConfig,
  });
}; 